import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { CommonModule } from "@angular/common";
import { Component, inject, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatDialog } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatRadioButton, MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatTableModule } from "@angular/material/table";
import { Store, select } from "@ngrx/store";
import { firstValueFrom, Observable, of } from "rxjs";
import { AppState } from "../../../app.state";
import { ConfirmDialogComponent } from "../../../confirm-dialog/confirm-dialog.component";
import { IAcuerdo, INuevoAcuerdoMrb } from "../../../interfaces/acuerdos";
import { IEntradaRequest } from "../../../interfaces/entradas";
import { LoadingService } from "../../../loading/loading.service";
import { OrderByPipe } from "../../../pipes/order-by.pipe";
import { AcuerdosService } from "../../../services/acuerdos/acuerdos.service";
import {
  cancelarAcuerdoMRB,
  cargaAcuerdos,
  cargaAcuerdosByTipoAcuerdo,
  cargaHistorico,
  loadResponsables,
  nuevoAcuerdoMRB,
  resetAcuerdos,
  updateTipoAcuerdo,
} from "../../../states/acuerdos-mrb/actions";
import {
  selectAcuedoActual,
  selectAcuerdoByTipo,
  selectNuevoAcuerdo,
} from "../../../states/acuerdos-mrb/selector";
import { selectCatalogos } from "../../../states/catalogos/selector";
import { DetalleTemaComponent } from "../detalle-tema/detalle-tema.component";
import { TableMrbComponent } from "../table-mrb/table-mrb.component";
import { ExcelFilesService } from "../../../services/excel-files/excel-files.service";
import {
  MatCalendarCellClassFunction,
  MatDatepicker,
  MatDatepickerInputEvent,
  MatDatepickerModule,
} from "@angular/material/datepicker";
import {
  MAT_DATE_LOCALE,
  provideNativeDateAdapter,
} from "@angular/material/core";
import { NuevoAcuerdoComponent } from "../nuevo-acuerdo/nuevo-acuerdo.component";
import { resetTemasAcuerdo } from "../../../states/temas/actions";

@Component({
  selector: "app-acuerdo-mrb",
  standalone: true,
  imports: [
    MatCardModule,
    MatTableModule,
    CommonModule,
    MatIconModule,
    MatRadioModule,
    MatRadioButton,
    FormsModule,
    ScrollingModule,
    //DetalleTemaComponent,
    MatButtonModule,
    TableMrbComponent,
    //OrderByPipe,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatInputModule,
    MatDatepickerModule,
    NuevoAcuerdoComponent,
  ],

  providers: [
    { provide: MAT_DATE_LOCALE, useValue: "es-MX" },
    provideNativeDateAdapter(),
  ],
  templateUrl: "./acuerdo-mrb.component.html",
  animations: [
    trigger("detailExpand", [
      state("collapsed,void", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
  styleUrl: "./acuerdo-mrb.component.css",
})
export class AcuerdoMrbListComponent {
  @ViewChild(MatDatepicker) datepicker!: MatDatepicker<Date>;

  columnsToDisplay: string[] = [
    "No",
    "fechaAcuerdo",
    "temas",
    "archivoUnico",
    "descargar",
  ];
  columnsToDisplayWithExpand = [...this.columnsToDisplay, "expand"];
  catAcuerdo = [
    { tipoAcuerdo: 1, descripcion: "Acuerdo actual" },
    { tipoAcuerdo: 2, descripcion: "Acuerdo nuevo" },
    { tipoAcuerdo: 3, descripcion: "Histórico" },
  ];

  public acuerdoSeleccionado: number = this.catAcuerdo[0].tipoAcuerdo;
  public dataSource$!: Observable<IAcuerdo[]>;
  public nuevoAcuerdo$!: Observable<INuevoAcuerdoMrb>;
  public nuevoAcuerdo: boolean = false;
  public selectFilterTemasUsuario$: Observable<IEntradaRequest[]>;
  public tipoAcuerdo: number = 0;
  public anio: string = "";
  public mes: string = "";
  private readonly store: Store<AppState> = inject(Store);
  public readonly stateCatalogo: any = this.store.pipe(select(selectCatalogos));
  public showHistorico = false;
  public anios = this.acuerdosService.getYears();
  public meses = this.acuerdosService.getMeses();
  public selectedDate: Date | null = null;
  public fechas: any[] = [];
  public formHistorico!: FormGroup;
  private formBuilder: FormBuilder = inject(FormBuilder);

  initForm() {
    this.formHistorico = this.formBuilder.group({
      mes: ["", [Validators.required]],
      anio: ["", [Validators.required]],
    });
  }

  dateClass: MatCalendarCellClassFunction<Date> = (cellDate, view) => {
    if (view !== "month") {
      this.setFooter();
      return "";
    }

    const date = cellDate.getDate();
    const filtroFechas = this.formatearFechas(this.fechas).filter((f) => {
      return (
        f.mes == this.getMonthFromDate(cellDate).mes &&
        f.anio == this.getMonthFromDate(cellDate).anio
      );
    });

    console.log("this.fechas", this.fechas);

    const resultadosHistorico = this.getFechasPorStatus(filtroFechas, "H");
    const resultadosNuevoActual = this.getFechasPorStatus(filtroFechas, [
      "N",
      "A",
    ]);

    if (resultadosHistorico.includes(date)) {
      return "historico";
    }
    if (resultadosNuevoActual.includes(date)) {
      return "actual";
    }

    this.setFooter();
    return "";
  };

  private getFechasPorStatus(
    fechas: any[],
    status: string | string[]
  ): number[] {
    return fechas
      .filter((ff) =>
        Array.isArray(status)
          ? status.includes(ff.status)
          : ff.status === status
      )
      .map((f) => f.dia);
  }

  getMonthFromDate(date: Date): any {
    const mes = date.getMonth() + 1;
    const dia = date.getDay();
    return { dia, mes, anio: date.getFullYear() };
  }

  formatearFechas(
    fechas: { agreement: string; type: string; color: string }[]
  ) {
    return fechas.map((f) => {
      const dateObj = new Date(f.agreement);
      return {
        date: f.agreement,
        mes: dateObj.getUTCMonth() + 1,
        dia: dateObj.getUTCDate(),
        anio: dateObj.getUTCFullYear(),
        status: f.type,
        color: f.color,
      };
    });
  }

  constructor(
    private acuerdosService: AcuerdosService,
    private loadingService: LoadingService,
    public dialog: MatDialog,
    private excelFilesService: ExcelFilesService
  ) {
    this.dataSource$ = of([]);
    this.selectFilterTemasUsuario$ = of([]);
  }

  async ngOnInit() {
    this.store.dispatch(cancelarAcuerdoMRB());
    this.initForm();
    this.store.dispatch(cargaAcuerdosByTipoAcuerdo({ tipoAcuerdo: 1 }));
    this.dataSource$ = this.store.pipe(select(selectAcuedoActual));
    this.nuevoAcuerdo$ = this.store.pipe(select(selectNuevoAcuerdo));
    this.nuevoAcuerdo$.subscribe((nuevoAcuerdo) => {
      console.log("nuevoAcuerdo ngOnInit change", nuevoAcuerdo);
      this.nuevoAcuerdo = nuevoAcuerdo.show;
    });

    const resFechas = await firstValueFrom(this.acuerdosService.consultaFechasAcuerdo())
    if (resFechas&&!resFechas.error) {
       this.fechas = resFechas.fechas;
    }
  }

  onChangeSelection(tipoAcuerdo: number) {
    this.store.dispatch(resetAcuerdos());
    this.store.dispatch(resetTemasAcuerdo());
    this.tipoAcuerdo = tipoAcuerdo;
    this.store.dispatch(cargaAcuerdosByTipoAcuerdo({ tipoAcuerdo }));

    //this.store.dispatch(updateTipoAcuerdo({ tipoAcuerdo: tipoAcuerdo }));
    this.dataSource$ = this.store.pipe(
      select(selectAcuerdoByTipo(tipoAcuerdo))
    );
  }

  getAcuerdosPorMA() {
    if (this.formHistorico.invalid) {
      // alert("Ingresa mes y año");
      this.formHistorico.markAllAsTouched();
      return;
    }

    const data = this.formHistorico.getRawValue();
    this.loadingService.show();
    this.acuerdosService
      .obtenerAcuerdos(3, data.mes, data.anio)
      .subscribe((data) => {
        this.showHistorico = !data.error;
        const historico: IAcuerdo[] = data.error ? [] : data.acuerdos;
        if (historico.length == 0) {
          this.showModalError(
            "Alerta",
            "No se encontraron acuerdos para las fechas seleccionadas."
          );
          this.store.dispatch(cargaHistorico({ historico: [] }));
        }
        if (historico.length > 0) {
          this.store.dispatch(cargaHistorico({ historico }));
        }
        this.loadingService.hide();
      });
  }

  getAcuerdos() {
    this.loadingService.show();
    this.acuerdosService.obtenerAcuerdos(3, "", "").subscribe((data) => {
      const historico: IAcuerdo[] = data.error ? [] : data.acuerdos;
      this.store.dispatch(cargaHistorico({ historico }));
      this.loadingService.hide();
    });
  }

  showModalError(title: string, message: string) {
    this.dialog.open(ConfirmDialogComponent, {
      width: "350px",
      data: {
        title,
        message,
        showButtons: {
          accept: true,
          cancel: false,
        },
        direction: "end",
        buttonsName: { cancel: "CANCELAR", accept: "ACEPTAR" },
      },
    });
  }

  downloadHistorico() {
    this.excelFilesService.exportHistorico();
  }

  addEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    this.selectedDate = event.value;
  }

  openPicker(picker: MatDatepicker<Date>, element: any) {
    picker.open();
  }
  setFooter() {
    const footer = document.querySelector(".mat-calendar-table");
    const existingFooter = footer?.querySelector("tfoot");

    if (footer && !existingFooter) {
      const tfoot = document.createElement("tfoot");
      const row = document.createElement("tr");
      const cell = document.createElement("td");
      cell.colSpan = 7;
      cell.innerHTML = `
      <div class="!flex !justify-end !items-center !gap-3 !p-3">
        <div class="!flex !items-center !gap-2">
          <div style="width: .75rem; height: .75rem; background-color: #aba9a9; border-radius: 100%;"></div>
          <span style="font-size:.75rem">Histórico</span>
        </div>
        <div class="!flex !items-center !gap-2">
          <div style="width: .75rem; height: .75rem; background-color: #ff9800; border-radius: 100%;"></div>
          <span style="font-size:.75rem" >Acuerdos Pendientes</span>
        </div>
      </div>
    `;
      row.appendChild(cell);
      tfoot.appendChild(row);
      footer.appendChild(tfoot);
    }
  }

  nuevoAcuerdoMRB() {
    this.store.dispatch(loadResponsables());
  }
}
